module.exports = __webpack_public_path__ + "img/web-app-icon.031be03b.svg";